
/**
 * Custom component for Bimini default menu sections.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 2.1.0
 * @copyright  Copyright (C) 2023-2026, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 * @changelog
 * 2026-02-17 (2.1.0) (jhoward)
 *   - Add new App\Library\Js\Components\Menu\Section\Chi_chineseNewYearSection.vue component for Chinese New Year section in Chi menus.
 *   - Implements custom template, props, and styles for the new section, including images and layout.
 */

import {defineComponent, PropType} from "vue";
import {Menu, MenuSection} from "../defs";
import Chi_DefaultSection from "./Chi_defaultSection.vue";

export default defineComponent({
  components: {
    Chi_DefaultSection,
  },
  name: "Chi_chineseNewYearSection",
  props: {
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    menu: {
      type: Object as PropType<Menu>,
      required: true
    },
    sectionModifier: {
      type: String,
      default: ''
    },
  },
})
